@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container player-outcome-container">
    @for (option of optionGroup.options; track option.id) {
        <ms-option
            [option]="option"
            [tracking]="{ source: tracking, moduleType: trackingModuleType }"
            [optionGroup]="optionGroup"
            [event]="event"
            [showPromoBadge]="!!crmPromotedOptionIdsMap[option.id]"
            [sourceOfPick]="sourceOfPick"
            [betDetails]="betDetails" />
    }
</div>
